import originGtag, { install } from 'ga-gtag';

import { GOOGLE_ANALYTIC_MEASUREMENT_ID } from '@/constants/env';

install(GOOGLE_ANALYTIC_MEASUREMENT_ID, {
  send_page_view: false,
});
const gtag = originGtag;
export default gtag;
